module.exports = __webpack_public_path__ + "static/media/earlybirdTrophy.369866c7.svg";